export const environment = {
  production: true,
  buildId: '3601995938622871',
  configFile: 'config.json',
};
